import { View, VStack } from "@gluestack-ui/themed";
import { NewTransactionIdentityController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { Button } from "@repo/core/components/core/Button";
import { IdentityTypeInput } from "@repo/core/components/forms/IdentityTypeInput";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const NewTransactionIdentity = () => {
  const {
    handleBack,
    isMobile,
    control,
    isSubmitting,
    handleOnSubmitForm,
    handleOnChangeIdentityType,
    selectedIdentityInputType,
    handleOnSelectProduct,
    title,
    showConfirmStoreModal
  } = NewTransactionIdentityController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect
        title={title}
        showConfirmStoreModal={showConfirmStoreModal}
        onBackPress={handleBack}
      >
        <Scaffolds.Form
          showHeader={false}
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$0" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                isLoading={isSubmitting}
                action="secondary"
                text="Continuar"
                onPress={handleOnSubmitForm}
              />
              <Button
                flex={isMobile ? undefined : 1}
                isDisabled={isSubmitting}
                variant="outline"
                action="negative"
                size="xl"
                text="Cancelar"
                onPress={handleBack}
              />
            </View>
          }
        >
          <VStack flex={1} gap={24} px="$4">
            <Text>Insira os dados para consultar:</Text>

            <IdentityTypeInput
              control={control}
              selectedInputType={selectedIdentityInputType}
              onChangeInputType={handleOnChangeIdentityType}
              onFetchCardFinish={handleOnSelectProduct}
              onSelectProduct={handleOnSelectProduct}
              showCardExpiryInput={false}
              shouldFetchOnCardSubmit={true}
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default NewTransactionIdentity;
